import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const CostCenterDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Cost Center"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Cost Center">
                {getFieldDecorator('costCenter', {
                 initialValue: data.costCenter,
                  rules: [{ required: true, message: 'Please input the Cost Center!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default CostCenterDialogForm;
